import { render, staticRenderFns } from "./classificator-text-area-input.vue?vue&type=template&id=8479c13e&scoped=true"
import script from "./classificator-text-area-input.vue?vue&type=script&lang=js"
export * from "./classificator-text-area-input.vue?vue&type=script&lang=js"
import style0 from "./classificator-text-area-input.vue?vue&type=style&index=0&id=8479c13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8479c13e",
  null
  
)

export default component.exports